export const opacityVariants = {
  visible: {
    opacity: 1,
    transition: {
      duration: 0.1
    }
  },
  invisible: {
    opacity: 0,
  },
};
export const springVariants = {
  visible: {
    y: 0,
    scale: 1,
    opacity: 1,
    transition: {
      damping: 10,
      stiffness: 200,
      mass: 0.1,
      type: "spring",
    }
  },
  invisible: {
    y: 24,
    opacity: 0,
    scale: 0.8
  },
};

export const bottomVariants = {
  visible: {
    y: 0,
    opacity: 1
  },
  invisible: {
    y: 12,
    opacity: 0,
  }
};
export const topVariants = {
  visible: {
    y: 0,
    opacity: 1
  },
  invisible: {
    y: -12,
    opacity: 0,
  }
};
export const poleVariants = {
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.128
    }
  },
  invisible: {
    x: 48,
    opacity: 0,
  }
};

export const leftFrameStage = {
  visible: {
    x: 0,
    y: 0,
    scale: 1,
    opacity: 1,
    transition: {
      damping: 10,
      stiffness: 200,
      mass: 0.1,
      type: "spring",
    }
  },
  invisible: {
    opacity: 0,
    x: -96,
    y: -96,
    scale: 0.94
  }
};
export const rightFrameStage = {
  visible: {
    x: 0,
    y: 0,
    scale: 1,
    transition: {
      damping: 10,
      stiffness: 200,
      mass: 0.1,
      type: "spring",
    }
  },
  invisible: {
    x: 96,
    y: -96,
    scale: 0.94
  }
};
export const leftFrameGalery = {
  visible: {
    x: 0,
    y: 0,
    scale: 1,
    opacity: 1,
    transition: {
      damping: 10,
      stiffness: 200,
      mass: 0.1,
      type: "spring",
    }
  },
  invisible: {
    opacity: 0,
    x: -96,
    y: -96,
    scale: 0.94
  }
};

export const leftVariants = {
  visible: {
    x: 0,
    opacity: 1
  },
  invisible: {
    x: -96,
    opacity: 0,
  }
};
export const rightVariants = {
  visible: {
    x: 0,
    opacity: 1,
  },
  invisible: {
    x: 96,
    opacity: 0,
  }
};

export const springViewport = { amount: 0.01, once: false };
export const homeViewport = { amount: 0.01, once: true };
